import * as mutationTypes from "./mutation-types";
import { tableHelper } from "@/helpers/table.helper";
import { getBlankCriteria, getBlankRecord } from "./helpers";
import { getBlankNextPreviousInfo } from "@/store/helpers";

export const state = getInitialState();

export function getInitialState() {
  return {
    listing: {
      levyCollectionId: null,
      criteria: getBlankCriteria(),
      criteriaInfo: tableHelper.getBlankCriteriaInfo(),
      data: [],
      paging: tableHelper.getDefaultPaging("Provider.Name", false),
      empty: false,
      loading: false,
      loaded: false
    },
    view: {
      levyCollectionId: null,
      providerId: null,
      data: getBlankRecord(),
      next: getBlankNextPreviousInfo(),
      previous: getBlankNextPreviousInfo(),
      loading: false,
      loaded: false
    },
    warnings: {
      levyCollectionId: null,
      data: [],
      expanded: null,
      loading: false,
      loaded: false
    },
    statusHistory: {
      levyCollectionId: null,
      providerId: null,
      loaded: false,
      loading: false,
      data: []
    },
    timeline: {
      levyCollectionId: null,
      providerId: null,
      loaded: false,
      loading: false,
      data: []
    },
    exists: {
      levyCollectionId: null,
      providerId: null,
      loading: false,
      loaded: false,
      exists: false
    },
    listingForProvider: {
      loading: false,
      loaded: false,
      providerId: null,
      data: []
    },
    providerUpload: {
      levyCollectionId: null,
      processing: false,
      isDryRun: true,
      validated: false,
      data: {},
      error: {
        show: false,
        details: {},
        hideMutation: mutationTypes.STATE_HIDE_ERROR,
        hideArgument: "providerUpload"
      }
    },
    pdfDocument: {
      loading: false
    },
    forTask: {
      loading: false,
      loaded: false,
      data: []
    },
    tasks: {
      loading: false,
      loaded: false,
      levyCollectionId: null,
      providerId: null,
      data: []
    },
    task: {
      processing: false,
      type: null,
      error: {
        show: false,
        details: {},
        hideMutation: mutationTypes.STATE_HIDE_ERROR,
        hideArgument: "task"
      }
    },
    inScopePreview: {
      loading: false,
      loaded: false,
      levyCollectionId: null,
      data: []
    },
    dismissWarning: {
      processing: false
    },
    assignedPaymentStatus: {
      saving: false,
      data: {
        assignedPaymentStatus: null,
        latePaymentDays: null
      },
      error: {
        show: false,
        details: {},
        hideMutation: mutationTypes.STATE_HIDE_ERROR,
        hideArgument: "assignedPaymentStatus"
      }
    },
    finalisation: {
      loading: false,
      saving: false,
      data: {
        assignedPaymentStatus: null,
        latePaymentDays: null,
        manuallyFinalisedReason: null,
        manuallyFinalised: null,
        manuallyFinalisedExplanation: null
      },
      error: {
        show: false,
        details: {},
        hideMutation: mutationTypes.STATE_HIDE_ERROR,
        hideArgument: "finalisation"
      }
    }
  };
}

export function getUnloadedState() {
  return {
    listing: { empty: false, loaded: false },
    view: { loaded: false },
    warnings: { loaded: false },
    statusHistory: { loaded: false },
    timeline: { loaded: false },
    exists: { loaded: false },
    listingForProvider: { loaded: false },
    forTask: { loaded: false },
    tasks: { loaded: false },
    inScopePreview: { loaded: false }
  };
}
